import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, ViewChild, effect, input, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CarouselComponent, CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { Product } from 'src/app/products/models/product.model';
import { RelatedProductsCardComponent } from "../related-products-card/related-products-card.component";

const customOptions: OwlOptions = {
  loop: true,
  margin: 10,
  autoplay: false,
  autoplayTimeout: 3000,
  autoplayHoverPause: true,
  autoplaySpeed: 2000,
  dotsSpeed: 500,
  autoplayMouseleaveTimeout: 5000,
  mouseDrag: true,
  smartSpeed: 400,
  dragEndSpeed: 350,
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 3,
    },
    1024: {
      items: 3,
    }
  },
  nav: false,
  dots: false
}

@Component({
  standalone: true,
  selector: 'webstore-related-products-carousel',
  templateUrl: './related-products-carousel.component.html',
  styleUrls: ['./related-products-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, CarouselModule, RelatedProductsCardComponent]
})
export class RelatedProductsCarouselComponent implements AfterViewInit, OnDestroy {

  customOptions = customOptions;

  readonly products = input<Product[]>([]);
  @ViewChild('owlCar') owlCar!: CarouselComponent;

  private _products = signal<Product[]>([]);
  private carouselRefreshTimeoutIds: Array<ReturnType<typeof setTimeout>> = [];

  constructor() {
    effect(() => {
      const inputProducts = this.products();
      this._products.set(inputProducts);
    });

    // Set up effect to refresh carousel when products change
    effect(() => {
      const products = this._products();
      if (products && products.length > 0 && this.owlCar) {
        // Use setTimeout to ensure DOM is ready
        const timeoutId = setTimeout(() => {
          this.refreshCarousel();
        }, 0);
        this.carouselRefreshTimeoutIds.push(timeoutId);
      }
    });
  }

  ngAfterViewInit() {
    // Initial carousel setup
    if (this.owlCar && this._products().length > 0) {
      const timeoutId = setTimeout(() => {
        this.refreshCarousel();
      }, 100);
      this.carouselRefreshTimeoutIds.push(timeoutId);
    }
  }

  private refreshCarousel() {
    if (this.owlCar) {
      try {
        // Force change detection by updating options
        const currentOptions = { ...this.customOptions };
        this.customOptions = { ...currentOptions };
      } catch (error) {
      }
    }
  }

  ngOnDestroy(): void {
    // Clear all timeouts to prevent memory leaks
    this.carouselRefreshTimeoutIds.forEach(timeoutId => clearTimeout(timeoutId));
    this.carouselRefreshTimeoutIds = [];
  }
}

